import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import SecondaryButton from '../components/common/SecondaryButton';
import Dropdown from 'react-bootstrap/Dropdown';


const Never = () => {
    const { t } = useTranslation();
    function getRandomItem(arr) {
        const randomIndex = Math.floor(Math.random() * arr.length);

        const item = arr[randomIndex];

        return item;
    }
    const [openDiv, setOpenDiv] = useState(false);
    const [randomItem, setRandomItem] = useState();
    const [sexQA, setSexQA] = useState(true);
    const [friendlyQA, setFriendlyQA] = useState(false);
    const [bothQA, setbothQA] = useState(false);
    const [questionType, setQuestionType] = useState(t('playwith18'));
    const handleSexQA = () => {
        setFriendlyQA(false);
        setbothQA(false);
        setQuestionType(t('playwith18'))
        setSexQA(true);
    };
    const handleFriendlyQA = () => {
        setSexQA(false);
        setbothQA(false);
        setQuestionType(t('playWFriends'))
        setFriendlyQA(true);
    };
    const handleBothQA = () => {
        setSexQA(false);
        setFriendlyQA(false);
        setQuestionType(t('both'))
        setbothQA(true);
    };
    const handleClick = () => {
        if (sexQA) {
            const item = setRandomItem(getRandomItem(hotq));
            hotq.splice(hotq.indexOf(item))
        } else if (bothQA) {
            const item = setRandomItem(getRandomItem(bothq));
            bothq.splice(bothq.indexOf(item))
        } else {
            const item = setRandomItem(getRandomItem(friendlyq));
            friendlyq.splice(friendlyq.indexOf(item))
        }

        setOpenDiv(true);
    };
    return (
            <div className="container d-flex flex-column justify-content-center gap-3 fade-in" style={{ padding: '1rem', maxWidth: '100%', overflowX: 'hidden' }}>
                 <h1 className='text-center mt-4 pt-1' style={{ fontSize: 'clamp(1.25rem, 4vw, 1.75rem)', lineHeight: '1.4', marginBottom: '0.5rem' }}>{t("neverH")}</h1>
                <div style={{ margin: '1.5rem 0', width: '100%' }} className="d-flex flex-column flex-md-row justify-content-between gap-3">
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                <p style={{ margin: 0, fontSize: 'clamp(0.95rem, 3vw, 1rem)' }}>{t("playW")}</p>
<Dropdown>
      <Dropdown.Toggle style={{backgroundColor:'#120651', minHeight: '48px', minWidth: '120px', fontSize: 'clamp(0.9rem, 2.5vw, 1rem)'}}  id="dropdown-basic">
        {questionType}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item className="dropdown-item" onClick={handleFriendlyQA} style={{ minHeight: '44px', padding: '0.75rem 1rem' }}>{t("playWFriends")}</Dropdown.Item >
    <Dropdown.Item className="dropdown-item" onClick={handleSexQA} style={{ minHeight: '44px', padding: '0.75rem 1rem' }}>{t("playwith18")}</Dropdown.Item >
    <Dropdown.Item className="dropdown-item" onClick={handleBothQA} style={{ minHeight: '44px', padding: '0.75rem 1rem' }}>{t("both")}</Dropdown.Item >
      </Dropdown.Menu>
    </Dropdown>
    </div>
                <SecondaryButton style={{
                width: '100%',
                maxWidth: '20rem',
                padding: '1rem 2rem',
                minHeight: '48px',
                border: 'none',
                color:'#35212A',
                backgroundColor: 'rgb(255, 222, 243)',
                fontSize: '1rem'
         }} handleFunc={handleClick} buttonText='randomQuestionButton' />
                </div>
                {openDiv && (
                    <div
                        className="fade-in-up"
                        style={{
                            border: '3px solid #FFDEF3',  
                            color: 'white',
                            padding: '1.25rem 1.5rem',
                            borderRadius: '0.5rem',
                            margin: '0 0.5rem',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        <p style={{ margin: 0, color:'black', fontSize: 'clamp(1rem, 3.5vw, 1.2rem)', lineHeight: '1.6' }}>{t("neverEver")} {t(randomItem)}</p>
                    </div>
                )}
                {sexQA && (
                    <ul className="d-flex flex-column gap-1" style={{ padding: 0, width: '100%' }}>
                        {hotq.map((item, idx) => (
                            <li
                                style={{
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    color: 'white',
                                    padding: '1.25rem 1.5rem',
                                    borderRadius: '0.5rem',
                                    margin: '0 0.5rem',
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                                }}
                                key={idx}
                                onMouseEnter={(e) => {
                                    if (window.matchMedia('(hover: hover)').matches) {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = '';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                }}
                            >
                                <p style={{ color:'black', margin: 0, fontSize: 'clamp(0.95rem, 3vw, 1.1rem)', lineHeight: '1.6' }}>
                                    {idx + 1} {t("neverEver")} <span style={{ color: 'black' }}>{t(item)}</span>
                                </p>
                            </li>
                        ))}
                    </ul>
                )}
                {friendlyQA && (
                    <ul className="d-flex flex-column gap-1" style={{ padding: 0, width: '100%' }}>
                        {friendlyq.map((item, idx) => (
                            <li
                                style={{
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    color: 'white',
                                    padding: '1.25rem 1.5rem',
                                    borderRadius: '0.5rem',
                                    margin: '0 0.5rem',
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                                }}
                                key={idx}
                                onMouseEnter={(e) => {
                                    if (window.matchMedia('(hover: hover)').matches) {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = '';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                }}
                            >
                                <p style={{color:'black', margin: 0, fontSize: 'clamp(0.95rem, 3vw, 1.1rem)', lineHeight: '1.6' }}>
                                    {idx + 1} {t("neverEver")} <span style={{ color: 'black' }}>{t(item)}</span>
                                </p>
                            </li>
                        ))}
                    </ul>
                )}
                {bothQA && (
                    <ul className="d-flex flex-column gap-1" style={{ padding: 0, width: '100%' }}>
                        {bothq.map((item, idx) => (
                            <li
                                style={{
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    color: 'white',
                                    padding: '1.25rem 1.5rem',
                                    borderRadius: '0.5rem',
                                    margin: '0 0.5rem',
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                                }}
                                key={idx}
                                onMouseEnter={(e) => {
                                    if (window.matchMedia('(hover: hover)').matches) {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = '';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                }}
                            >
                                <p style={{color:'black', margin: 0, fontSize: 'clamp(0.95rem, 3vw, 1.1rem)', lineHeight: '1.6' }}>
                                    {idx + 1} {t("neverEver")} <span style={{ color: 'black' }}>{t(item)}</span>
                                </p>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
    );
};

let hotq = [
    "neverq-1",
"neverq-2",
"neverq-3",
"neverq-4",
"neverq-5",
"neverq-6",
"neverq-7",
"neverq-8",
"neverq-9",
"neverq-10",
"neverq-11",
"neverq-12",
"neverq-13",
"neverq-14",
"neverq-15",
"neverq-16",
"neverq-17",
"neverq-18",
"neverq-19",
"neverq-20",
"neverq-21",
"neverq-22",
"neverq-23",
"neverq-24",
"neverq-25",
"neverq-26",
"neverq-27",
"neverq-28",
"neverq-29",
"neverq-30",
"neverq-31",
"neverq-32",
"neverq-33",
"neverq-34",
"neverq-35",
"neverq-36",
"neverq-37",
];
let friendlyq = [
    "neverf-1",
"neverf-2",
"neverf-3",
"neverf-4",
"neverf-5",
"neverf-6",
"neverf-7",
"neverf-8",
"neverf-9",
"neverf-10",
"neverf-11",
"neverf-12",
"neverf-13",
"neverf-14",
"neverf-15",
"neverf-16",
"neverf-17",
"neverf-18",
"neverf-19",
"neverf-20",
"neverf-21",
"neverf-22",
"neverf-23",
"neverf-24",
"neverf-25",
"neverf-26",
"neverf-27",
"neverf-28",
"neverf-29",
"neverf-30",
"neverf-31",
"neverf-32",
"neverf-33",
"neverf-34",
"neverf-35",
"neverf-36",
"neverf-37",
"neverf-38",
"neverf-39",
];
let bothq = hotq.concat(friendlyq);
export default Never;
